import { Message } from "element-ui";

export default {
  data() {
    return {
      T: [],
      doTopicIndex: 0
    };
  },
  methods: {
    swipeTopic(isRight) {
      if (0 === isRight) {
        //上
        if (this.doTopicIndex === 0) {
          Message.info("已经是第一题了");
          return;
        }

        this.doTopicIndex--;
        this.$nextTick(() => {
          window.scroll(0, 0);
          document.body.scrollTop = 0; //解决ios莫名其妙响应错位并且出去空白的问题
          //this.onlyPlayOneAudio();
        });
      }
      if (1 === isRight) {
        //下一题
        if (this.doTopicIndex === this.T.length - 1) {
          Message.info("已经是最后一题了");
          return;
        }

        this.doTopicIndex++;
        this.$nextTick(() => {
          window.scroll(0, 0);
          document.body.scrollTop = 0; //解决ios莫名其妙响应错位并且出去空白的问题
          //this.onlyPlayOneAudio();
        });
      }
    }
  },
  computed: {
    topicTotal: function() {
      let len = this.T.length;
      if (len === 0) return 0;
      let lastTopic = this.T[len - 1];
      let index = lastTopic.index;
      if (index.length === 1) {
        return index[0];
      }
      return index[index.length - 1];
    }
  }
};
